import { useState } from "react";
import { Listbox } from "@headlessui/react";
import { Fragment } from "react";
import { SelectAvatar } from "../organisms/SelectAvatar";

const ColumnDropdownAvatar = ({ data }) => {
  const [selectedOption, setSelectedOption] = useState(data[1]);
  return (
    <td className="whitespace-nowrap px-3 py-10 pr-10 text-sm text-gray-500 min-w-60 flex items-start  ">
      <div className="">
        <Fragment>
          <Listbox value={selectedOption} onChange={setSelectedOption}>
            <div>
              <div className="relative">
                <SelectAvatar
                  options={data}
                  selected={selectedOption}
                  setSelected={setSelectedOption}
                  tittle="Selecciona un usuario"
                />
              </div>
            </div>
          </Listbox>
        </Fragment>
      </div>
    </td>
  );
};

export default ColumnDropdownAvatar;
